import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchQboItemsAPI } from '@services/WebApiService';
import { canShowPagination } from '@utilities';
import BaseSetting from '@config/BaseSetting';

let currentAbortController = null;

const qboFetchObjectItemsAsync = createAsyncThunk(
  'QboObjectItems/fetchQboObjectItems',
  async (
    { qboRealmId, objectName, pageLink, order, orderBy, top, skip, query, statuses },
    { getState }
  ) => {
    // Cancel the previous request
    if (currentAbortController) {
      currentAbortController.abort();
    }

    // Create a new controller for this request
    currentAbortController = new AbortController();

    const { accessToken } = getState().auth;
    const data = await fetchQboItemsAPI(
      accessToken,
      qboRealmId,
      objectName,
      pageLink,
      {
        top,
        skip,
        order,
        orderBy,
        query,
        intuitDeletedStatus: statuses,
      },
      currentAbortController.signal,
      BaseSetting.searchTimeout
    );
    return { ...data, query: query || '' };
  }
);

const { pending, fulfilled, rejected } = qboFetchObjectItemsAsync;

const qboFetchObjectItemsExtraReducers = {
  [pending]: (state) => {
    state.fetchingQboObjectItems = true;
    state.QboObjectItems.value = [];
    state.error = null;
  },
  [rejected]: (state, action) => {
    if (action.error?.code) {
      state.error = action.error;
    }

    if (action.error?.code === 'ERR_CANCELED') {
      state.fetchingQboObjectItems = true;
      state.error = null;
    } else {
      state.fetchingQboObjectItems = false;
    }
  },
  [fulfilled]: (state, action) => {
    state.fetchingQboObjectItems = false;

    if (action.payload.error) {
      state.error = action.payload.error;
    } else if (action?.payload?.companyName && action?.payload?.query === state.currentSearchTerm) {
      const showPagination = canShowPagination(state.QboObjectItems.showPagination, action);

      const {
        companyName,
        backupStatus,
        lastCompletedBackupAt,
        lastBackupAt,
        totalRecords,
        initialBackupAt,
        value,
        nextLink,
        prevLink,
      } = action.payload;

      state.QboObjectItems = {
        companyName,
        backupStatus,
        lastCompletedBackupAt,
        lastBackupAt,
        totalRecords,
        initialBackupAt,
        value,
        nextLink,
        prevLink,
        showPagination,
      };
    }
  },
};

export { qboFetchObjectItemsAsync, qboFetchObjectItemsExtraReducers };
